import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import api from "@/lib/api";
import { useSettings } from "@/context/SettingsContext";
import { Navbar } from "@/components/public/Navbar";
import { OrderSection } from "@/components/public/OrderSection";
import { Footer } from "@/components/public/Footer";

export default function OrderPage() {
  const [products, setProducts] = useState([]);
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { bank } = useSettings();
  const productId = params.get("product");
  const reorderId = params.get("reorder");
  const [reorder, setReorder] = useState(null);
  const selected = productId ? products.find((p) => p.id === productId) || null : null;

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get("/products").then((r) => setProducts(r.data)).catch(() => {});
    if (reorderId) api.get(`/orders/${reorderId}/reorder`).then((r) => setReorder(r.data)).catch(() => setReorder(false));
  }, [reorderId]);

  return (
    <div className="bg-sky-950 min-h-screen" data-testid="order-page">
      <Navbar solid />
      <div className="max-w-5xl mx-auto px-5 lg:px-8 pt-24 lg:pt-28">
        <button data-testid="order-page-back" onClick={() => navigate("/")} className="inline-flex items-center gap-2 text-sky-200 hover:text-white text-sm font-semibold">
          <ArrowLeft className="w-4 h-4" /> Back to products
        </button>
        {reorder && (
          <div data-testid="reorder-banner" className="mt-4 rounded-2xl bg-sky-400/15 border border-sky-300/30 text-sky-100 text-sm px-5 py-3">
            Welcome back, <strong className="text-white">{reorder.customer_name}</strong>! We've pre-filled your last order <span className="font-mono-cw text-sky-300">{reorder.order_code}</span> — adjust anything and place it again.
          </div>
        )}
        {reorder === false && (
          <div data-testid="reorder-missing" className="mt-4 rounded-2xl bg-rose-500/15 border border-rose-300/30 text-rose-100 text-sm px-5 py-3">
            We couldn't find that previous order. Please fill in the form below.
          </div>
        )}
      </div>
      <OrderSection products={products} selected={selected} reorder={reorder || null} bankDetails={bank} />
      <Footer />
    </div>
  );
}
